import axios from "axios";
import { useContext, useState } from "react";
import { AuthContext } from "../contexts/user-context/user-context";
import { API_ENDPOINT } from "../configurations/global.config";

export const useImage = () => {

    const [isUploading, setIsUploading] = useState(false);
    const [isGettingPresignedUrl, setIsGettingPresignedUrl] = useState(false);
    const { config } = useContext(AuthContext);

    const uploadImage = async (imageFile: File) => {

        let imageUrl = '';
        setIsUploading(true);

        const formData = new FormData();
        formData.append('image', imageFile);

        try {
        // Replace with your actual API endpoint
        const response = await axios.post<{image_url: string}>(
            `${API_ENDPOINT}/v1/images/`,
            formData,
            config,
        );

            // On success, show the success message
            setIsUploading(false);
            imageUrl = response.data.image_url;
        } catch (err) {
            console.error('Failed to upload image', err);
        } finally {
        setIsUploading(false);
        }
        return imageUrl;
  };

    const getPresignedUrl = async (unsignedUrl: string) => {
        setIsGettingPresignedUrl(true);
        try {
            const response = await axios.get<{presigned_url: string}>(
                `${API_ENDPOINT}/v1/images/?unsigned_url=${unsignedUrl}`,
                config,
            );

            return response.data.presigned_url;
        } catch (err) {
            console.error('Failed to get presigned url', err);
            return null;
        } finally {
            setIsGettingPresignedUrl(false);
        }
    }


    return {
        isUploading,
        uploadImage,
        getPresignedUrl,
        isGettingPresignedUrl,
    }
}

